// extracted by mini-css-extract-plugin
export default {"gearCheck":"OrgsDishesEditListGear_gearCheck__pBP7z","gearHeader":"OrgsDishesEditListGear_gearHeader__emj1z","placeHolderShimmer":"OrgsDishesEditListGear_placeHolderShimmer__YdO6Q"};